import { graphql } from 'react-relay';

import createMutation from '../../../../relay/createMutation';

const mutation = graphql`
  mutation RejectTutorMutation($input: RejectTutorMutationInput!) {
    rejectTutor(input: $input) {
      clientMutationId
    }
  }
`;

export default variables => createMutation(mutation)(variables);



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/mutations/RejectTutorMutation.js